import React from 'react';

import { mdiMagnify } from '@lumapps/lumx/icons';
import { Combobox, Icon, Size, Text } from '@lumapps/lumx/react';
import { useTranslate } from '@lumapps/translations';

import { QUICK_SEARCH } from '../../keys';

export interface SearchForOptionProps {
    /** Classname to set on the option */
    className?: string;
    /** Action when the option is selected  */
    onSelect: () => void;
    /** Current query set on the search box */
    query: string;
    /** data-id to set on the root <li> element */
    'data-id'?: string;
}

/**
 * Component to display an option that invites the
 * user to "search for" their query.
 *  */
export const SearchForOption: React.FC<SearchForOptionProps> = ({ className, onSelect, query, 'data-id': dataId }) => {
    const { translateAndReplaceWithComponents } = useTranslate();

    const searchForMessageWithBold = translateAndReplaceWithComponents(QUICK_SEARCH.SEARCH_FOR, {
        query: <strong key="query">{query}</strong>,
    });

    return (
        <Combobox.Option
            id="quick-search-search-for"
            className={className}
            before={<Icon icon={mdiMagnify} size={Size.s} />}
            onClick={onSelect}
            value={query}
            data-id={dataId}
        >
            <Text as="span" truncate>
                {searchForMessageWithBold}
            </Text>
        </Combobox.Option>
    );
};
